import { ContentContainer } from "components/ui/display/ContentContainer";
import styled from "styled-components";
import { parseDateToTimestamp } from "utilities/dateAndTime";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const RecentNotesContainer = ({notes, projects, notebooks}) => {
    return (
        <StyledRecentNotesContainer padding='none'>
            <div className="recentNotesHeader">
                <MaterialIcon name='book_5' weight={300} size='sm'/> Siste notater <div/>
            </div>
            <div className="recentNotesContent">
                {
                    notes.map(note => {
                        let parent = projects.find(prj => prj.projectUuid === note.noteParentUuid);
                        if(!parent) parent = notebooks.find(nbs => nbs.notebookUuid === note.noteParentUuid);
                        if(!parent) return null;
                        return (
                            <NoteThumbnail
                                key={note.noteUuid}
                                note={note}
                            />
                        ) 
                    })
                }
            </div>
        </StyledRecentNotesContainer>
    )
}

const StyledRecentNotesContainer = styled(ContentContainer)`
    flex: 1;
    overflow: hidden;
    min-height: 400px;
    max-height: 500px;

    div.recentNotesHeader
    {
        padding: ${({theme}) => theme.spacing.md};
        border-bottom: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
        display: flex;
        align-items: center;
        gap: ${({theme}) => theme.spacing.md};
        font-weight: 600;

        .icon
        {   
            color: ${({theme}) => theme.colors.mutedForeground};
        }

        > div
        {
            height: 32px;
        }
    }

    div.recentNotesContent
    {
        padding: ${({theme}) => theme.spacing.md};
        overflow: auto;
        flex: 1;
    }
`

const NoteThumbnail = ({note}) => {
    return (
        <StyledNoteThumbnail>
            <div className="noteIcon">
                <MaterialIcon name='draft' weight={300}/>
            </div>
            <div className="noteContent">
                <div className="noteTitle">
                    {note.noteTitle}
                </div>
                <div className="noteDescription">
                    <div className="noteLastEdit">
                        <MaterialIcon
                            name='calendar_today'
                            weight={300}
                            size="sm"
                            color={({theme}) => theme.colors.mutedForeground}
                        />
                        {parseDateToTimestamp(new Date(note.noteTimestamp))}
                    </div>
                    {
                        note.noteContentSummary && note.noteContentSummary.length !== 0 ?
                        <>
                            <div className="dot"/>
                            <div className="noteSummary">
                                {note.noteContentSummary}
                            </div>
                        </>
                        : null
                    }
                    
                    
                </div>
            </div>
            <a href={'/doc/' + note.noteUuid} target="_blank" rel='noreferrer'>
                <MaterialIcon
                    name='arrow_outward'
                    weight={300}
                    size='sm'
                    color={({theme}) => theme.colors.mutedForeground}
                />
            </a>
            
        </StyledNoteThumbnail>
    )
}

const StyledNoteThumbnail = styled.div`
    border-bottom: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
    padding: ${({theme}) => theme.spacing.md} ${({theme}) => theme.spacing.sm};
    display: flex;
    align-items: center;
    gap: ${({theme}) => theme.spacing.md};
    overflow: hidden;
    width: 100%;
    cursor: pointer;

    &:hover
    {
        background: ${({theme}) => theme.colors.neutralSecondaryBackground};
        border-radius: 10px;
    }

    div.noteIcon
    {
        border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
        background: ${({theme}) => theme.colors.neutralSecondaryBackground};
        display: flex;
        align-items: center;
        justify-content: center;
        padding: ${({theme}) => theme.spacing.sm};
        border-radius: ${({theme}) => theme.cornerRadius.sm};
    }

    div.noteContent
    {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.sm};
        overflow: hidden;

        div.noteTitle
        {
            font-weight: 500;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        div.noteDescription
        {
            display: flex;
            align-items: center;
            gap: ${({theme}) => theme.spacing.sm};
            color: ${({theme}) => theme.colors.mutedForeground};
            overflow: hidden;
            flex: 1;

            div.noteLastEdit
            {
                display: inline-flex;
                align-items: center;
                gap: ${({theme}) => theme.spacing.sm};
            }

            div.dot
            {
                height: 6px;
                width: 6px;
                background: ${({theme}) => theme.colors.mutedForeground};
                border-radius: 999px;
            }

            div.noteSummary
            {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                flex: 1 0 0;
            }
        }
    }

`